import { userSession } from "../observers/userObserver";
import config from "./config";
import { sharedData } from "../sharedData/sharedData";

// Fetch transactions based on requestId
export const fetchTransactions = async (requestId) => {
  try {
    const token = userSession.getToken(); // Retrieve token from localStorage
    const response = await fetch(`${config["backend-url"]}/get_transactions`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (response.ok) {
      return data.transaction_ids || []; // Return transaction IDs or an empty array
    } else {
      console.error("Failed to fetch transactions", data);
      throw new Error("Failed to fetch transactions");
    }
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};

// Fetch transaction details based on transactionId
export const fetchTransactionDetails = async (transactionId, signal) => {
  try {
    const token = userSession.getToken(); // Retrieve token from localStorage
    let response = await fetch(`${config["backend-url"]}/get_transaction_details`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ transaction_id: transactionId }),
      signal: signal, // Pass the signal for aborting the request
    });

    if (response.status === 401) {
      userSession.refresh(); // Refresh token if needed
      response = await fetch(`${config["backend-url"]}/get_transaction_details`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ transaction_id: transactionId }),
      });
    }

    const data = await response.json();

    if (response.ok) {
      return data.transaction_details || null; // Return transaction details or null
    } else {
      console.error("Failed to fetch transaction details", data);
      throw new Error("Failed to fetch transaction details");
    }
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};

export const fetchQuickfillTransactionDetails = async (transactionId, signal) => {
  try {
    const token = userSession.getToken(); // Retrieve token from localStorage
    let response = await fetch(`${config["backend-url"]}/get_Quicktransaction_details`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ transaction_id: transactionId }),
      signal: signal, // Pass the signal for aborting the request
    });

    if (response.status === 401) {
      userSession.refresh(); // Refresh token if needed
      response = await fetch(`${config["backend-url"]}/get_Quicktransaction_details`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ transaction_id: transactionId }),
      });
    }

    const data = await response.json();

    if (response.ok) {
      return data.transaction_details || null; // Return transaction details or null
    } else {
      console.error("Failed to fetch transaction details", data);
      throw new Error("Failed to fetch transaction details");
    }
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};

// Update transaction
export const updateTransaction = async (payload) => {
  try {
    const token = userSession.getToken(); // Retrieve token from localStorage
    const requestId = sharedData.get("requestId"); // Get requestId from shared data
    
    // Add requestId to payload if it exists
    const updatedPayload = requestId ? { ...payload, requestId } : payload;
    
    const response = await fetch(`${config["backend-url"]}/update_transaction`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(updatedPayload),
    });

    const data = await response.json();

    if (response.ok) {
      return data; // Return the updated transaction data
    } else {
      console.error("Failed to update transaction", data);
      throw new Error("Failed to update transaction");
    }
  } catch (error) {
    console.error("Error during API call:", error);
    throw error;
  }
};